import {useGlobalAlertStore} from '../../store/GlobalAlertStore';

const Alert = {
  alert: (
    title: string,
    message?: string,
    _buttons?: any[],
    _options?: any,
  ) => {
    useGlobalAlertStore.getState().show(title, message, 'error');
  },
};

export default Alert;
